import { EMPTY_ARRAY } from 'constants/defaults';
import { xhrStatusUIState } from 'redux/reusable/xhrStatus';
import type { IState } from 'redux/state';
import { createSelector } from 'reselect';

const readProjectIds = (state: IState) => state.pins.projectIds || EMPTY_ARRAY;
const readReportIds = (state: IState) => state.pins.reportResult || EMPTY_ARRAY;
const readReportEntities = (state: IState) => state.pins.reportEntities;
const readPinsFetchStatus = (state: IState) => state.pins.xhrStatus;

export const getPinnedProjectIds = readProjectIds;

export const getPinnedReportIds = readReportIds;

export const getPinnedReportIdsSet = createSelector([getPinnedReportIds], ids => new Set(ids));

export const getPinnedProjectIdsSet = createSelector([getPinnedProjectIds], ids => new Set(ids));

export const getPinnedProjectsFetchStatus = createSelector([readPinsFetchStatus], xhrStatus =>
  xhrStatusUIState(xhrStatus, 'projects')
);
export const getPinnedProjectsLoading = createSelector(
  [getPinnedProjectsFetchStatus],
  status => !status.hasInitialized || status.isLoading
);

export const getPinnedReportsFetchStatus = createSelector([readPinsFetchStatus], xhrStatus =>
  xhrStatusUIState(xhrStatus, 'reports')
);
export const getPinnedReportsLoading = createSelector(
  [getPinnedReportsFetchStatus],
  status => !status.hasInitialized || status.isLoading
);

export const getPinnedReportEntities = readReportEntities;
